var _rect, _rect2, _path, _path2, _g, _rect3, _path3, _path4, _path5, _line, _circle, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJiraIntegrationSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307,
    height: 83,
    viewBox: "0 0 307 83",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 7.5,
    stroke: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3652,
    y: 48.7593,
    width: 9.52381,
    height: 7.93651,
    fill: "#414141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7778 27.8809C38.709 29.6163 35.7778 34.3676 33.2698 38.4417C28.4444 46.283 25.1958 51.5317 24.8042 52.1454C23.5767 54.0925 22 56.7168 22 56.8227C22 56.865 26.6561 56.9073 32.3492 56.9073L42.6878 56.8967L44.8042 53.447C45.9683 51.5528 47.0688 49.7645 47.2487 49.4682L47.5767 48.9497L48.1587 49.8809C48.4868 50.3994 48.9524 51.1719 49.2063 51.5952C49.4603 52.0184 49.7884 52.5475 49.9365 52.7803C50.0847 53.0026 50.4762 53.6375 50.8042 54.1772C51.1429 54.7168 51.672 55.5634 51.9788 56.0608L52.5397 56.9602L57.2698 56.992C61.6825 57.0131 62 57.0026 62 56.8332C62 56.738 61.6296 56.0502 61.1746 55.32C60.3704 54.0502 59.1005 51.9761 58.8783 51.5952C58.8254 51.4999 58.3492 50.738 57.8307 49.902C55.4392 46.0502 55.2593 45.7539 55.2487 45.6481C55.2487 45.5952 55.1958 45.5211 55.1429 45.4893C55.037 45.4258 54.1693 44.0184 54.1693 43.9126C54.1693 43.8809 54.0635 43.7116 53.9259 43.5317C53.7884 43.3518 53.6402 43.1295 53.6085 43.0449C53.5661 42.9602 53.3862 42.6745 53.2169 42.41C53.0476 42.1454 52.8466 41.8174 52.7725 41.6692C52.6984 41.5211 52.6138 41.3835 52.5714 41.3518C52.5291 41.32 52.4127 41.1295 52.3069 40.9285C52.1905 40.7274 52 40.41 51.873 40.2195C51.7354 40.0396 51.6296 39.8385 51.6296 39.775C51.6296 39.6904 50.2011 39.6481 46.8677 39.6375L42.1164 39.6057L44.2328 36.1666C45.4074 34.2724 46.4021 32.6534 46.455 32.5475C46.5185 32.4206 46.328 32.029 45.672 30.9602C44.127 28.4735 42.582 25.9761 42.2011 25.3518C42 25.0131 41.8201 24.738 41.7884 24.738C41.7566 24.738 40.8571 26.156 39.7778 27.8809ZM42.9524 41.4258C43.4921 42.2936 44.1799 43.3941 44.4974 43.8914C44.8148 44.3888 45.2698 45.119 45.5026 45.5317C45.9894 46.3888 46.0317 46.4629 46.6243 47.4047C46.8677 47.7962 47.1429 48.2618 47.2381 48.4417L47.4074 48.7592H43.1852H38.963L38.5079 49.2565C37.9259 49.9126 34.381 53.6269 33.2381 54.7909L32.3492 55.6904L33.0582 54.537C33.4497 53.902 33.8413 53.2565 33.9365 53.1084C34.0212 52.9602 34.2011 52.6639 34.328 52.4629C35.4709 50.6428 36.2857 49.2883 36.4021 49.0237C36.4762 48.8438 36.836 48.2301 37.1852 47.6481C37.545 47.0661 38.5185 45.4682 39.3545 44.1031C41.3439 40.8438 41.9471 39.8703 41.9577 39.8703C41.9683 39.8703 42.4127 40.5687 42.9524 41.4258Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_73502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 48,
    width: 8,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2734 48.7856H38.9842L35.4427 52.9263L31.6826 56.8809L36.2734 48.7856Z",
    fill: "#414141"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_73502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5234 56.9602L36.5234 48.7856H40.4123L39.8798 56.1167L31.5234 56.9602Z",
    fill: "#414141"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 7.5,
    stroke: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.624 26.7856H263.256C263.256 30.6176 266.361 33.7232 270.193 33.7232H273.024V36.456C273.027 40.2848 276.129 43.3872 279.957 43.3888V28.1184C279.957 27.3824 279.36 26.7856 278.624 26.7856Z",
    fill: "#2684FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.019 34.4434H255.651C255.653 38.2722 258.757 41.3746 262.584 41.3762H265.415V44.1186C265.419 47.9474 268.523 51.0466 272.352 51.0466V35.7762C272.354 35.0402 271.757 34.4434 271.019 34.4434Z",
    fill: "url(#paint0_linear_1_73502)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.411 42.0962H248.043C248.043 45.9282 251.149 49.0338 254.981 49.0338H257.821V51.7666C257.824 55.5906 260.92 58.693 264.745 58.6994V43.429C264.744 42.693 264.147 42.0962 263.411 42.0962Z",
    fill: "url(#paint1_linear_1_73502)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 83,
    y1: 36,
    x2: 224,
    y2: 36,
    stroke: "#4DC7B5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 36,
    r: 12,
    fill: "#4DC7B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.485 31.0131C158.192 31.0719 158.316 30.9544 155.127 34.1458L152.157 37.1165L151.006 35.9681C149.764 34.7329 149.775 34.7423 149.475 34.693C149.299 34.6625 149.127 34.6906 148.93 34.7799C148.831 34.8268 148.723 34.9184 148.477 35.1627C148.209 35.4327 148.143 35.5126 148.077 35.6488C148.007 35.7991 148 35.8319 148 36.0362C148 36.2312 148.009 36.2781 148.068 36.412C148.134 36.5552 148.249 36.6773 149.944 38.3775C151.25 39.6856 151.786 40.2069 151.872 40.2562C152.034 40.3454 152.267 40.3501 152.429 40.2656C152.509 40.2257 153.514 39.2347 156.2 36.5435C159.688 33.0539 159.866 32.8707 159.932 32.7251C159.991 32.5912 160 32.5443 160 32.3494C160 32.0276 159.937 31.9008 159.587 31.5392C159.291 31.2339 159.148 31.1188 158.983 31.0578C158.842 31.0038 158.622 30.985 158.485 31.0131Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_73502",
    x1: 272.025,
    y1: 34.4675,
    x2: 265.528,
    y2: 41.2468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_73502",
    x1: 264.854,
    y1: 42.1689,
    x2: 257.339,
    y2: 49.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIntegrationSuccess);
export default __webpack_public_path__ + "static/media/jira-integration-success.4725164c1083d22a627b07d3cdc89769.svg";
export { ForwardRef as ReactComponent };